export default __webpack_public_path__ + "media/images/logos/logo_grey-217e81e9634c2d68544132b3b922a325.svg";